export default __webpack_public_path__ + "static/media/myp-sprite-6b51e86bb8bfd3bdb7135c022bc7ac6b.png";